import React from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Row, Col, Card, CardBody, CardTitle,
} from 'reactstrap';
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';
import BaseGrid from '../../components/Common/BaseGrid';

// import { post } from '../../helpers/api_helper';
import * as url from '../../helpers/url_helper';

function Notify(props) {
  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const user = JSON.parse(localStorage.getItem('authUser'));

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Row>
          <Col xxl="10">
            <Card>
              <CardBody>
                <CardTitle className="h4">{props.t('My Notifications')}</CardTitle>

                <BaseGrid
                  url={url.GET_NOTIFICATIONS}
                  filters={`user.id=${user.id}`}
                  config={
                  {
                    columns: {
                      id: { label: 'ID', sort: true },
                      title: { label: 'Title', sort: true },
                      message: { label: 'Message', sort: false },
                    },
                    pagination: {
                      sort: 'id',
                      direction: 'desc',
                      perPage: 30,
                    },
                  }
                  }
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
}

Notify.defaultProps = {
  t: (x) => (x),
};

Notify.propTypes = {
  t: PropTypes.any,
};

export default connect(() => ({

}), {})(withTranslation()(Notify));
